import React from "react";
import { Redirect } from 'react-router-dom'
import {logout} from "../../redux/actions/authAction.js"
import {connect} from "react-redux";


@connect((store)=>{
  return {

  }
})
export default class Logout extends React.Component {
  constructor(props){
super(props);

  }

componentWillMount(){
  this.props.dispatch(logout())
}


  render() {
    if(!this.props.isAuthenticated){
      return(
      <Redirect to={{
       pathname: "/login"
     }}/>)
    }
    return null;
  }
}
